// import config from 'config';

/* eslint-disable */
import { authHeader } from '../_helpers';
import { api } from '../_helpers/api';
import * as Cookies from 'js-cookie';
import Axios from 'axios';

// export const userService = {
//     login,
//     logout,
//     getAll
// };

export async function getDataAnswer() {
    return api.fetchData('/asessment/count-asessment').then(res => {
        return res.data;
    });
}

export async function getDataAnswerUser(type) {
    return api.fetchData('/asessment/data-answer',{
        type : type
    }).then(res => {
        return res.data;
    });
}

export async function submitSurvey(payload) {
    const _baseUrl = process.env.VUE_APP_API_URL + '/api/v1';

    return await Axios({
        method: "post",
        url: _baseUrl + '/asessment/store-survey',
        data: payload,
        headers: { 
            Authorization: 'Bearer ' + Cookies.get('x-access-token'),
            "Content-Type": "multipart/form-data" 
        },
    }).then(res => {
        return res.data;
    });
}

export async function getAsessment() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    let lang = localStorage.getItem('currentLanguage') ?  localStorage.getItem('currentLanguage') : process.env.VUE_APP_LANG;
    return fetch(`${process.env.VUE_APP_URL_RW}/api/tade/get-list-asessment?code=${process.env.VUE_APP_CODE}&lang=${lang}`, requestOptions).then(handleResponse);
}

export async function submitLogData(form) {
    return api.postData('/asessment/store-temp-data',form,true)
        // .then(handleResponse)
        .then(response => {
            return response.data;
        });

}

function login(username, password) {
    return api.postData('/auth/login',{
        'username' : username,
        'password' : password
    },true)
        // .then(handleResponse)
        .then(response => {
            console.log(response);
            // login successful if there's a jwt token in the response
            if (response.access_token) {
                Cookies.set('x-access-token', response.access_token);
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(response.user));
            }

            return response.user;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}



function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
